import React from 'react'
import Link from 'gatsby-link'
import { OutboundLink } from 'gatsby-plugin-google-analytics'
import {
  Segment,
  Breadcrumb,
  Icon,
  Header,
  Card,
  Label,
} from 'semantic-ui-react'
import Helmet from 'react-helmet'
import {
  InstantSearch,
  Hits,
  SearchBox,
  Highlight,
  RefinementList,
  Pagination,
  CurrentRefinements,
  ClearRefinements,
  PoweredBy,
} from 'react-instantsearch-dom'
// import 'instantsearch.css/themes/algolia.css'
import 'instantsearch.css/themes/reset.css'

// const Sidebar = () => (
//   <div className="sidebar">
//     <RefinementList attribute="category" />
//   </div>
// )

function Search() {
  return (
    <div>
      {/* <CurrentRefinements />
        <ClearRefinements /> */}
      <header>
        <SearchBox
          translations={{ placeholder: 'Search by name or category' }}
        />
      </header>
      {/* <RefinementList attribute="category" /> */}
      <Hits hitComponent={Product} />
      <Pagination />
    </div>
  )
}

function Product({ hit }) {
  return (
    <div style={{ marginTop: '10px' }}>
      <Card
        fluid
        centered
        key={hit.id}
        style={{
          maxWidth: 600,
        }}
      >
        <Segment>
          <Header
            as="h2"
            // className="hit-name"
          >
            <Link to={`/product/${hit.slug}/`}>
              <Highlight attribute="name" hit={hit} />
            </Link>
          </Header>

{/* GROWTH LEVERS */}
<div style={{ marginBottom: '10px' }}>
          { hit.growthLever[0]? 
          (
            <Label
            basic
            size="tiny"
            style={{ marginBottom: '3px' }}
            ><Icon name="rocket" /> {hit.growthLever[0].name}</Label>
          )
           : <span/>}

 { hit.growthLever[1]? 
          (
            <Label
            basic
            size="tiny"
            style={{ marginBottom: '3px' }}
            ><Icon name="rocket" /> {hit.growthLever[1].name}</Label>
          )
           : <span/>}

            { hit.growthLever[2]? 
          (
            <Label
            basic
            size="tiny"
            style={{ marginBottom: '3px' }}
            ><Icon name="rocket" /> {hit.growthLever[2].name}</Label>
          )
           : <span/>}
           
           { hit.growthLever[3]? 
          (
            <Label
            basic
            size="tiny"
            style={{ marginBottom: '3px' }}
            ><Icon name="rocket" /> {hit.growthLever[3].name}</Label>
          )
           : <span/>}


 { hit.growthLever[4]? 
          (
            <Label
            basic
            size="tiny"
            style={{ marginBottom: '3px' }}
            ><Icon name="rocket" /> {hit.growthLever[4].name}</Label>
          )
           : <span/>}
</div>




          {/* <div>
        {hit.growthLever.map(node => (
          <Label
            key={node.id}
            basic
            size="tiny"
            style={{ marginBottom: '3px' }}
          >
            <Icon name="rocket" />
            {node.name}{' '}
          </Label>
        ))}
      </div>
      <br /> */}



{/* PRIMARY CATEGORIES */}
<div>
{ hit.primaryCategories[0]? 
  (
    <Label
    basic
    size="small"
    style={{ marginBottom: '3px' }}
    >{hit.primaryCategories[0].name}</Label>
  )
   : <span/>}

   { hit.primaryCategories[1]? 
    (
      <Label
      basic
      size="small"
      style={{ marginBottom: '3px' }}
      >{hit.primaryCategories[1].name}</Label>
    )
     : <span/>}

     { hit.primaryCategories[2]? 
      (
        <Label
        basic
        size="small"
        style={{ marginBottom: '3px' }}
        >{hit.primaryCategories[2].name}</Label>
      )
       : <span/>}

       { hit.primaryCategories[3]? 
        (
          <Label
          basic
          size="small"
          style={{ marginBottom: '3px' }}
          >{hit.primaryCategories[3].name}</Label>
        )
         : <span/>}

          {/* <div>
            {hit.primaryCategories ? (
              hit.primaryCategories.map(node => (
                <Label
                  key={node.id}
                  basic
                  size="small"
                  style={{ marginBottom: '3px' }}
                >
                  {node.name}
                </Label>
              ))
            ) : (
              <span />
            )}
          </div> */}

{/* SUBCATEGORIES */}



   { hit.subCategories[0]? 
        (
          <Label
          basic
          size="mini"
          style={{ marginBottom: '3px' }}
          >{hit.subCategories[0].name}</Label>
        )
         : <span/>}

            { hit.subCategories[1]? 
        (
          <Label
          basic
          size="mini"
          style={{ marginBottom: '3px' }}
          >{hit.subCategories[1].name}</Label>
        )
         : <span/>}

            { hit.subCategories[2]? 
        (
          <Label
          basic
          size="mini"
          style={{ marginBottom: '3px' }}
          >{hit.subCategories[2].name}</Label>
        )
         : <span/>}

            { hit.subCategories[3]? 
        (
          <Label
          basic
          size="mini"
          style={{ marginBottom: '3px' }}
          >{hit.subCategories[3].name}</Label>
        )
         : <span/>}


              { hit.subCategories[4]? 
        (
          <Label
          basic
          size="mini"
          style={{ marginBottom: '3px' }}
          >{hit.subCategories[4].name}</Label>
        )
         : <span/>}

</div>

          {/* <div>
            {hit.subCategories ? (
              hit.subCategories.map(node => (
                <Label
                  key={node.id}
                  basic
                  size="mini"
                  style={{ marginBottom: '3px' }}
                >
                  {node.name}
                </Label>
              ))
            ) : (
              <span />
            )}
          </div> */}


          
        </Segment>
      </Card>
    </div>
  )
}

const SearchPage = () => (
  <div style={{ maxWidth: 1260, margin: '0 auto' }}>
    <Helmet>
      <title>Search | Find Growth Tools</title>
    </Helmet>
    <Segment basic>
      <Breadcrumb>
        <Breadcrumb.Section>
          <Link to="/" style={{ color: '#dcddde' }}>
            <Icon name="angle left" />Home
          </Link>
        </Breadcrumb.Section>

        {/* <Breadcrumb.Section active>About</Breadcrumb.Section> */}
      </Breadcrumb>
    </Segment>
    <h1
      style={{
        fontSize: '3.25rem',
        color: '#fff',
      }}
    >
      Search
    </h1>
    <br />

    <InstantSearch
      appId="WI4XJZH7LY"
      apiKey="686b45257c3f41bffe0b34ee1f06d2f4"
      indexName="prod_Index"
    >
      <Search />
      {/* Search widgets will go there */}
      {/* <Sidebar/> */}
      <PoweredBy />
    </InstantSearch>
  </div>
)

export default SearchPage



// WEBPACK FOOTER //
// ./src/pages/search.js